import { axiosInstance } from '../Axios';
import { loader, storeData } from './UiReducer';
const { createSlice } = require('@reduxjs/toolkit');

const EtravReducer = createSlice({
	name: 'Etrav',
	initialState: {
		success: false,
		error: null,
		loading: false,
		ticket: null,
	},
	reducers: {
		ticketRequest(state, action) {
			state.loading = true;
		},
		ticketSuccess(state, action) {
			state.loading = false;
			state.ticket = action.payload;
			state.error = null;
		},
		ticketFail(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

const { actions } = EtravReducer;

export const { ticketRequest, ticketSuccess, ticketFail } = actions;

export const flightTicketEtravDispatch =
	(bodyData, history) => async (dispatch) => {
		try {
			dispatch(ticketRequest());
			const config = {
				headers: {
					'Content-Type': 'application/json',
					'Client-Service': 'srk-client',
					'Auth-Key': 'srkapi',
				},
			};
			const { data } = await axiosInstance.post(
				'FlyEtrav/flightticketing',
				bodyData,
				config
			);
			console.log(data);
			dispatch(ticketSuccess(data));
			if (data.status === 200) {
				history.push('/ticket');
			}
		} catch (error) {
			dispatch(
				ticketFail(
					error.response && error.response.data.message
						? error.response.data.message
						: error.message
				)
			);
		}
	};

export default EtravReducer;
